<ng-content *ngIf="active"></ng-content>
